import type { FaireProductEntity } from "../../entity_types/product";

export const p_5r7z8jnehy: FaireProductEntity = {
  token: "p_5r7z8jnehy",
  type: "product",
  name: "Dk. Green Long Vest",
  brandToken: "b_5m4wqw135i",
  brandName: "Panache Apparel Co.",
  imageUrl: "https://cdn.faire.com/fastly/895670ce684bbeb77555f7a81cb5912ab9350dd1dd04d5f348c5bc1dea89a297.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c371f75114f131680253dc83e60ddb1922cace57de6f085f19b64d35958d11d0.jpeg",
    "https://cdn.faire.com/fastly/2a05d0e8d6afcff49f95e8d20a6e7d0616f050a48460fda66cf5926ba10a289d.jpeg",
    "https://cdn.faire.com/fastly/1183a79cfab5dfcaebe8d168738bdf35e3d0bd3834635a83d51c51bbc85933c8.jpeg"
  ],
  priceDollars: 26.95,
  description: "The dark green long vest designed with a cozy relaxed fit, featuring a quilted design throughout the front and back, a sleeveless silhouette, and a full-length front zipper closure. With a stand collar neckline, front flap pockets, and a longline cut, this versatile vest is perfect for layering over everyday outfits during cooler days.\n\n100% Polyester\n\nPre-pack 1-2-2-2-1 (XS-XL)\n\nMin. Qty: 8",
  tags: [],
  msrpDollars: 67.38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:40.941Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
